export const COMMUNITY_STATUS = {
  COMMUNITY_CANDIDATE: 'COMMUNITY_CANDIDATE',
  COMMUNITY_IRRELEVANT: 'COMMUNITY_IRRELEVANT',
  INACTIVE_COMMUNITY_MEMBER: 'INACTIVE_COMMUNITY_MEMBER',
  LEFT_COMMUNITY: 'LEFT_COMMUNITY',
  COMMUNITY_MEMBER: 'COMMUNITY_MEMBER',
  COMMUNITY_PENDING_JOIN_VALIDATION: 'COMMUNITY_PENDING_JOIN_VALIDATION',
};

export const ELEMENTS_TYPES = {
  COMMUNITY_INVITE: 'COMMUNITY_INVITE',
  COMMUNITY_REMINDER: 'COMMUNITY_REMINDER',
};

export const SEGMENTS = {
  cql: 'cql',
};

export const COMMUNITY_SOURCE_VALIDATION_STATUSES = {
  PENDING: 'PENDING',
  FAIL: 'FAIL',
  SUCCESS: 'SUCCESS',
};
